import Vue from 'vue';
import Router from 'vue-router';
import LoginService from './services/acesso/login.service';
import MonitoramentoVisitaService from "./services/nfse/monitoramento.visita.service";
import UrlService from './services/nfse/url.service';
import UsuarioAcessoService from './services/nfse/usuario.acesso.service';
const AcessoEmpresa = () => import(/* webpackChunkName: "acesso.empresa" */'./views/AcessoEmpresa.vue')
const AcessoFiscal = () => import(/* webpackChunkName: "acesso.fiscal" */'./views/AcessoFiscal.vue')
const UsuarioContribuinte = () => import(/* webpackChunkName: "usuario.contribuinte" */'./views/UsuarioContribuinte.vue')
const Autenticacao = () => import(/* webpackChunkName: "autenticacao" */'./views/Autenticacao.vue')
const Configuracao = () => import(/* webpackChunkName: "conf" */'./views/Configuracao.vue')
const ConsultaDaps = () => import(/* webpackChunkName: "consulta.daps" */'./views/ConsultaDaps.vue')
const ConsultaNfse = () => import(/* webpackChunkName: "consulta.nfse" */'./views/ConsultaNfse.vue')
const ConsultaDps = () => import(/* webpackChunkName: "consulta.dps" */'./views/ConsultaDps.vue')
const ContrConfiguracao = () => import(/* webpackChunkName: "contr.conf" */'./views/ContrConfiguracao.vue')
const Credenciamento = () => import(/* webpackChunkName: "credenciamento" */'./views/Credenciamento.vue')
const Contribuintes = () => import(/* webpackChunkName: "credenciamento" */'./views/Contribuintes.vue')
const DeclaracaoNormal = () => import(/* webpackChunkName: "declaracao.normal" */'./views/DeclaracaoNormal.vue')
const DamNormal = () => import(/* webpackChunkName: "dam.normal" */'./views/DamNormal.vue')
const DeclaracaoSubstituicao = () => import(/* webpackChunkName: "declaracao.substituicao" */'./views/DeclaracaoSubstituicao.vue')
const DamSubstituicao = () => import(/* webpackChunkName: "dam.substituicao" */'./views/DamSubstituicao.vue')
const RdtGerenciar = () => import(/* webpackChunkName: "rdt.gerenciar" */'./views/RdtGerenciar.vue')
const DeclaracaoSimplificada = () => import(/* webpackChunkName: "declaracao.simplificada" */'./views/DeclaracaoSimplificada.vue')
const DeclaracaoCartorio = () => import(/* webpackChunkName: "declaracao.cartorio" */'./views/DeclaracaoCartorio.vue')
const RelatorioDeclaracao = () => import(/* webpackChunkName: "relatorio.declaracao" */'./views/RelatorioDeclaracao.vue')
const RelatorioDam = () => import(/* webpackChunkName: "relatorio.dam" */'./views/RelatorioDam.vue')
const RelatorioNotas = () => import(/* webpackChunkName: "relatorio.notas" */'./views/RelatorioNotas.vue')
const RelatorioNotasRecebidas = () => import(/* webpackChunkName: "relatorio.notas.recebidas" */'./views/RelatorioNotasRecebidas.vue')
const RelatorioDapsTomados = () => import(/* webpackChunkName: "relatorio.daps.tomados" */'./views/RelatorioDapsTomados.vue')
const EmissaoDaps = () => import(/* webpackChunkName: "emissao.daps" */'./views/EmissaoDaps.vue')
const EmissaoNfse = () => import(/* webpackChunkName: "emissao.nfse" */'./views/EmissaoNfse.vue')
const Expired = () => import(/* webpackChunkName: "expired" */'./views/Expired.vue')
const AutenticacaoDigital = () => import(/* webpackChunkName: "autenticacao.digital" */'./views/AutenticacaoDigital.vue')
const AcessoDireto = () => import(/* webpackChunkName: "acesso.direto" */'./views/AcessoDireto.vue')
const Login = () => import(/* webpackChunkName: "login" */'./views/Login.vue');
const NotFound = () => import(/* webpackChunkName: "notfound" */'./views/NotFound.vue')
const PerfilAcessoCadastro = () => import(/* webpackChunkName: "perfil.acesso.cadastro" */'./views/PerfilAcessoCadastro.vue')
const PerfilAcessoListagem = () => import(/* webpackChunkName: "perfil.acesso.listagem" */'./views/PerfilAcessoListagem.vue')
const PerfilCadastro = () => import(/* webpackChunkName: "perfil.cadastro" */'./views/PerfilCadastro.vue')
const PerfilListagem = () => import(/* webpackChunkName: "perfil.listagem" */'./views/PerfilListagem.vue')
const RecuperarSenha = () => import(/* webpackChunkName: "recuperar.senha" */'./views/RecuperarSenha.vue')
const SelecaoEmpresa = () => import(/* webpackChunkName: "selecao.empresa" */'./views/SelecaoEmpresa.vue')
const Servico = () => import(/* webpackChunkName: "servico" */'./views/Servico.vue')
const UnAlthorized = () => import(/* webpackChunkName: "unalthorized" */'./views/UnAlthorized.vue')
const ReciboRetencao = () => import(/* webpackChunkName: "recibo.retencao" */'./views/ReciboRetencao.vue')
const ConsultaRps = () => import(/* webpackChunkName: "consulta.rps" */'./views/ConsultaRps.vue')
const DenunciaFiscal = () => import(/* webpackChunkName: "denuncia.fiscal" */'./views/DenunciaFiscal.vue')
const CaixaMensagem = () => import(/* webpackChunkName: "caixa.nensagem" */'./views/CaixaMensagem.vue')
const GeracaoAutomatica = () => import(/* webpackChunkName: "geracao.automatica" */'./views/GeracaoAutomatica.vue')
const TseArquivoNF = () => import(/* webpackChunkName: "tse.arquivo.nf" */'./views/TseArquivoNF.vue')
const EmolumentosListagem = () => import(/* webpackChunkName: "emolumentos" */'./views/EmolumentosListagem.vue')
const EmolumentoCadastro = () => import(/* webpackChunkName: "emolumento.cadastro" */'./views/EmolumentoCadastro.vue')
const ContribFornecedorCadastro = () => import(/* webpackChunkName: "contrb.fornecedor.cadastro" */'./views/ContribFornecedorCadastro.vue')
const ContribFornecedorConsulta = () => import(/* webpackChunkName: "contrb.fornecedor.consulta" */'./views/ContribFornecedorConsulta.vue')
const ObrasCadastro = () => import(/* webpackChunkName: "obras.cadastro" */'./views/ObrasCadastro.vue')
const ObrasConsulta = () => import(/* webpackChunkName: "obras.consulta" */'./views/ObrasConsulta.vue')
const TipoDescontoCadastro = () => import(/* webpackChunkName: "tipo.desconto.cadastro" */'./views/TipoDescontoCadastro.vue')
const TipoDescontoConsulta = () => import(/* webpackChunkName: "tipo.desconto.consulta" */'./views/TipoDescontoConsulta.vue')
const TipoObraCadastro = () => import(/* webpackChunkName: "tipo.obra.cadastro" */'./views/TipoObraCadastro.vue')
const TipoObraConsulta = () => import(/* webpackChunkName: "tipo.obra.consulta" */'./views/TipoObraConsulta.vue')
const TransferirEscrituracoes = () => import(/* webpackChunkName: "transferencia.escrituracoes" */'./views/TransferirEscrituracoes.vue')
const TransferenciasCadastro = () => import(/* webpackChunkName: "transferencias.cadastro" */'./views/TransferenciasCadastro.vue')
const TransferenciasConsulta = () => import(/* webpackChunkName: "transferencias.consulta" */'./views/TransferenciasConsulta.vue')
const ConsultaNfseRps = () => import(/* webpackChunkName: "consulta.nfse.rps" */'./views/ConsultaNfseRps.vue')
const ConsultaNfseNacional = () => import(/* webpackChunkName: "consulta.nfse.nacional" */'./views/ConsultaNfseNacional.vue')
const ContribuinteVinculoCadastro = () => import(/* webpackChunkName: "contribuinte.vinculo.cadastro" */'./views/ContribuinteVinculoCadastro.vue')
const ImportacaoAceite = () => import(/* webpackChunkName: "importacao.aceite" */'./views/ImportacaoAceite.vue')
const IntegracaoCadastro = () => import(/* webpackChunkName: "integracao" */'./views/IntegracaoCadastro.vue');
const AvisoCadastro = () => import(/* webpackChunkName: "aviso.cadastro" */'./views/AvisoCadastro.vue');
const AvisoConsulta = () => import(/* webpackChunkName: "aviso.consulta" */'./views/AvisoConsulta.vue');
const ConsultaEmailsEnviados = () => import(/* webpackChunkName: "emails.enviados.consulta" */'./views/ConsultaEmailsEnviados.vue');
const RelatorioConsultaLogs = () => import(/* webpackChunckName: "relatorio.consulta.logs" */'./views/RelatorioConsultaLogs.vue');
const CooperadoCadastro = () => import(/* webpackChunckName: "cooperado.cadastro" */'./views/CooperadoCadastro.vue');
const CooperadoConsulta = () => import(/* webpackChunckName: "cooperado.consulta" */'./views/CooperadoConsulta.vue');
const PgccCadastro = () => import(/* webpackChunkName: "pgcc.cadastro" */'./views/PgccCadastro.vue');
const PgccListagem = () => import(/* webpackChunkName: "pgcc.listagem" */'./views/PgccListagem.vue');
const DeclaracaoPlanoConta = () => import(/* webpackChunkName: "declaracao.planoconta" */'./views/DeclaracaoPlanoConta.vue');
const MonitoramentoVisita = () => import(/* webpackChunckName: "monitoramento.visita" */'./views/MonitoramentoVisita.vue');
const AidfCadastro = () => import(/* webpackChunckName: "aidf.cadastro" */'./views/AidfCadastro.vue');
const AidfConsulta = () => import(/* webpackChunckName: "aidf.consulta" */'./views/AidfConsulta.vue');
const SorteioAuditoralNfse = () => import(/* webpackChunckName: "sorteio.auditoral.nfse" */'./views/SorteioAuditoralNfse.vue');
const BlacklistEmails = () => import(/* webpackChunckName: "blacklist.emails" */'./views/BlacklistEmails.vue');
const UrlConsulta = () => import(/* webpackChunkName: "url.cadastro" */'./views/UrlConsulta.vue');
const UrlCadastro = () => import(/* webpackChunckName: "url.consulta" */'./views/UrlCadastro.vue');
const DeclaracaoConcessionaria = () => import(/* webpackChunckName: "declaracao.concesseionaria" */'./views/DeclaracaoConcessionaria.vue');
const TarifaCadastro = () => import(/* webpackChunckName: "tarifa.cadastro" */'./views/TarifaCadastro.vue');
const TarifaListagem = () => import(/* webpackChunckName: "tarifa.listagem" */'./views/TarifaListagem.vue');
const PedagioCadastro = () => import(/* webpackChunckName: "pedagio.cadastro" */'./views/PedagioCadastro.vue');
const PedagioListagem = () => import(/* webpackChunckName: "pedagio.listagem" */'./views/PedagioListagem.vue');
const CategoriaTarifaCadastro = () => import(/* webpackChunckName: "categoria.tarifa.cadastro" */'./views/CategoriaTarifaCadastro.vue');
const CategoriaTarifaListagem = () => import(/* webpackChunckName: "categoria.tarifa.listagem" */'./views/CategoriaTarifaListagem.vue');
const SolicitacoesCancelamentoNfse = () => import(/* webpackChunckName: "solicitacoes.cancelamento.nfse" */'./views/SolicitacoesCancelamentoNfse.vue');

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/emissaoNfse',
    name: 'emissaoNfse',
    component: EmissaoNfse,
    props: { testeValidacao: false }
  },
  {
    path: '/emissaoNfseLote',
    name: 'emissaoNfseLote',
    component: EmissaoNfse,
    props: { testeValidacao: false }
  },
  {
    path: '/emissaoNfseTeste',
    name: 'emissaoNfseTeste',
    component: EmissaoNfse,
    props: { testeValidacao: true }
  },
  {
    path: '/consultaNfse',
    name: 'consultaNfse',
    component: ConsultaNfse,
    props: { testeValidacao: false }
  },
  {
    path: '/consultaDpsTeste',
    name: 'consultaDpsTeste',
    component: ConsultaDps,
    props: { testeValidacao: true }
  },
  {
    path: '/consultaDps',
    name: 'consultaDps',
    component: ConsultaDps,
    props: { testeValidacao: false }
  },
  {
    path: '/consultaNfseTeste',
    name: 'consultaNfseTeste',
    component: ConsultaNfse,
    props: { testeValidacao: true }
  },
  {
    path: '/emissaoDaps',
    name: 'emissaoDaps',
    component: EmissaoDaps
  },
  {
    path: '/emissaoNotaTomador',
    name: 'emissaoNotaTomador',
    component: EmissaoDaps,
    props: { notaTomador: true }
  },
  {
    path: '/consultaDaps',
    name: 'consultaDaps',
    component: ConsultaDaps
  },
  {
    path: '/consultaNotaTomador',
    name: 'consultaNotaTomador',
    component: ConsultaDaps,
    props: { notaTomador: true }
  },
  {
    path: '/servico',
    name: 'servico',
    component: Servico
  },
  {
    path: '/perfil',
    name: 'perfil',
    component: PerfilListagem
  },
  {
    path: '/perfilCadastro',
    name: 'perfilCadastro',
    component: PerfilCadastro
  },
  {
    path: '/perfilAcesso',
    name: 'perfilAcesso',
    component: PerfilAcessoListagem
  },
  {
    path: '/perfilAcessoCadastro',
    name: 'perfilAcessoCadastro',
    component: PerfilAcessoCadastro
  },
  {
    path: '/emolumentos',
    name: 'emolumento',
    component: EmolumentosListagem
  },
  {
    path: '/emolumentoCadastro',
    name: 'emolumentoCadastro',
    component: EmolumentoCadastro
  },
  {
    path: '/acessoEmpresa',
    name: 'acessoEmpresa',
    component: AcessoEmpresa
  },
  {
    path: '/acessoFiscal',
    name: 'acessoFiscal',
    component: AcessoFiscal
  },
  {
    path: '/usuarioContribuinte',
    name: 'usuarioContribuinte',
    component: UsuarioContribuinte
  },
  {
    path: '/selecaoEmpresa',
    name: 'selecaoEmpresa',
    component: SelecaoEmpresa
  },
  {
    path: '/configuracoes',
    name: 'configuracao',
    component: Configuracao
  },
  {
    path: '/configContribuinte',
    name: 'configContribuinte',
    component: ContrConfiguracao
  },
  {
    path: '/autenticacao',
    name: 'autenticacao',
    component: Autenticacao
  },
  {
    path: '/credenciamento',
    name: 'credenciamento',
    component: Credenciamento
  },
  {
    path: '/contribuintes',
    name: 'contribuintes',
    component: Contribuintes
  },
  {
    path: '/declaracaoNormal',
    name: 'declaracaoNormal',
    component: DeclaracaoNormal
  },
  {
    path: '/damNormal',
    name: 'damNormal',
    component: DamNormal
  },
  {
    path: '/relatorioDeclaracao',
    name: 'relatorioDeclaracao',
    component: RelatorioDeclaracao
  },
  {
    path: '/relatorioDam',
    name: 'relatorioDam',
    component: RelatorioDam
  },
  {
    path: '/relatorioNotasRecebidas',
    name: 'relatorioNotasRecebidas',
    component: RelatorioNotasRecebidas
  },
  {
    path: '/relatorioDapsTomados',
    name: 'relatorioDapsTomados',
    component: RelatorioDapsTomados
  },
  {
    path: '/relatorioNotas',
    name: 'relatorioNotas',
    component: RelatorioNotas
  },
  {
    path: '/declaracaoSubstituicao',
    name: 'declaracaoSubstituicao',
    component: DeclaracaoSubstituicao
  },
  {
    path: '/damSubstituicao',
    name: 'damSubstituicao',
    component: DamSubstituicao
  },
  {
    path: '/rdtGerenciar',
    name: 'rdtGerenciar',
    component: RdtGerenciar
  },
  {
    path: '/declaracaoSimplificada',
    name: 'declaracaoSimplificada',
    component: DeclaracaoSimplificada,
    props: { cartorio: true }
  },
  {
    path: '/declaracaoCartorio',
    name: 'declaracaoCartorio',
    component: DeclaracaoSimplificada
  },
  {
    path: '/declaracaoCartorioEm',
    name: 'declaracaoCartorioEm',
    component: DeclaracaoCartorio
  },
  {
    path: '/declaracaoPlanoConta',
    name: 'declaracaoPlanoConta',
    component: DeclaracaoPlanoConta
  },
  {
    path: '/recuperarSenha',
    name: 'recuperarSenha',
    component: RecuperarSenha
  },
  {
    path: '/reciboRetencao',
    name: 'reciboRetencao',
    component: ReciboRetencao
  },
  {
    path: '/consultaRps',
    name: 'consultaRps',
    component: ConsultaRps
  },
  {
    path: '/denunciaFiscal',
    name: 'denunciaFiscal',
    component: DenunciaFiscal
  },
  {
    path: '/geracaoAutomatica',
    name: 'geracaoAutomatica',
    component: GeracaoAutomatica
  },
  {
    path: '/tseArquivoNF',
    name: 'tseArquivoNF',
    component: TseArquivoNF
  },
  {
    path: '/caixaMensagem',
    name: 'caixaMensagem',
    component: CaixaMensagem
  },
  {
    path: '/fornecedorConsulta',
    name: 'ContribFornecedorConsulta',
    component: ContribFornecedorConsulta
  },
  {
    path: '/fornecedorCadastro',
    name: 'ContribFornecedorCadastro',
    component: ContribFornecedorCadastro
  },
  {
    path: '/tipoDescontoConsulta',
    name: 'TipoDescontoConsulta',
    component: TipoDescontoConsulta
  },
  {
    path: '/tipoDescontoCadastro',
    name: 'TipoDescontoCadastro',
    component: TipoDescontoCadastro
  },
  {
    path: '/tipoObraConsulta',
    name: 'TipoObraConsulta',
    component: TipoObraConsulta
  },
  {
    path: '/tipoObraCadastro',
    name: 'TipoObraCadastro',
    component: TipoObraCadastro
  },
  {
    path: '/obrasConsulta',
    name: 'ObrasConsulta',
    component: ObrasConsulta
  },
  {
    path: '/obrasCadastro',
    name: 'ObrasCadastro',
    component: ObrasCadastro
  },
  {
    path: '/transferirEscrituracoes',
    name: 'TransferirEscrituracoes',
    component: TransferirEscrituracoes
  },
  {
    path: '/transferenciasConsulta',
    name: 'TransferenciasConsulta',
    component: TransferenciasConsulta
  },
  {
    path: '/transferenciasCadastro',
    name: 'TransferenciasCadastro',
    component: TransferenciasCadastro
  },
  {
    path: '/consultaNfseRps',
    name: 'ConsultaNfseRps',
    component: ConsultaNfseRps
  },
  {
    path: '/consultaNfseNacional',
    name: 'ConsultaNfseNacional',
    component: ConsultaNfseNacional,
    props: { testeValidacao: false }
  },
  {
    path: '/consultaNfseNacionalTeste',
    name: 'ConsultaNfseNacionalTeste',
    component: ConsultaNfseNacional,
    props: { testeValidacao: true }
  },
  {
    path: '/contribuinteVinculoCadastro',
    name: 'ContribuinteVinculoCadastro',
    component: ContribuinteVinculoCadastro
  },
  {
    path: '/importacaoAceite',
    name: 'ImportacaoAceite',
    component: ImportacaoAceite
  },
  {
    path: '/integracaoCadastro',
    name: 'IntegracaoCadastro',
    component: IntegracaoCadastro
  },
  {
    path: '/avisoCadastro',
    name: 'avisoCadastro',
    component: AvisoCadastro
  },
  {
    path: '/avisoConsulta',
    name: 'avisoConsulta',
    component: AvisoConsulta
  },
  {
    path: '/emailsEnviados',
    name: 'EmailsEnviadosConsulta',
    component: ConsultaEmailsEnviados
  },
  {
    path: '/relatorioConsultaLogs',
    name: 'RelatorioConsultaLogs',
    component: RelatorioConsultaLogs
  },
  {
    path: '/cooperadoCadastro',
    name: 'CooperadoCadastro',
    component: CooperadoCadastro
  },
  {
    path: '/cooperadoConsulta',
    name: 'CooperadoConsulta',
    component: CooperadoConsulta
  },
  {
    path: '/pgcc',
    name: 'pgcc',
    component: PgccListagem
  },
  {
    path: '/pgccCadastro',
    name: 'pgccCadastro',
    component: PgccCadastro
  },
  {
    path: '/aidfCadastro',
    name: 'aidfCadastro',
    component: AidfCadastro
  },
  {
    path: '/aidfConsulta',
    name: 'aidfConsulta',
    component: AidfConsulta
  },
  {
    path: '/sorteioAuditoralNfse',
    name: 'sorteioAuditoralNfse',
    component: SorteioAuditoralNfse
  },
  {
    path: '/blacklistEmails',
    name: 'blacklistEmails',
    component: BlacklistEmails
  },
  {
    path: '/urlConsulta',
    name: 'urlConsulta',
    component: UrlConsulta
  },
  {
    path: '/urlCadastro',
    name: 'urlCadastro',
    component: UrlCadastro
  },
  {
    path: '/declaracaoConcessionaria',
    name: 'declaracaoConcessionaria',
    component: DeclaracaoConcessionaria
  },
  {
    path: '/tarifaCadastro',
    name: 'tarifaCadastro',
    component: TarifaCadastro
  },
  {
    path: '/tarifaListagem',
    name: 'tarifa',
    component: TarifaListagem
  },
  {
    path: '/pedagioCadastro',
    name: 'pedagioCadastro',
    component: PedagioCadastro
  },
  {
    path: '/pedagioListagem',
    name: 'pedagio',
    component: PedagioListagem
  },
  {
    path: '/categoriaTarifaCadastro',
    name: 'categoriaTarifaCadastro',
    component: CategoriaTarifaCadastro
  },
  {
    path: '/categoriaTarifaListagem',
    name: 'categoriaTarifa',
    component: CategoriaTarifaListagem
  },
  {
    path: '/solicitacoesCancelamentoNfse',
    name: 'solicitacoesCancelamentoNfse',
    component: SolicitacoesCancelamentoNfse
  },
  {
    path: '/404',
    component: NotFound
  },
  {
    path: '/401',
    component: UnAlthorized
  },
  {
    path: '/expired',
    component: Expired
  },
  {
    path: '/autenticacaoDigital',
    component: AutenticacaoDigital
  },
  {
    path: '/acessoDireto',
    component: AcessoDireto
  },
  {
    path: '/monitoramentoVisita',
    component: MonitoramentoVisita
  },
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/url/:id',
    name: 'generateUrl',
    component: {
      render: (h) => h('div'), // Componente vazio, para não dar erro
    },
    beforeEnter: (to, from, next) => {
      const urlId = to.params.id;
      UrlService.getUrlGpi(urlId)
        .then((response) => {
          const generatedUrl = response.data;
          if (generatedUrl) {
            window.open(generatedUrl, '_blank');
          }
        })
        .finally(() => {
          next(false); // Cancela a navegação do Vue Router
        });
    },
  },
]

const router = new Router({
  routes
})
router.beforeEach((to, from, next) => {

  if (!to.fullPath.includes('/login') && !to.fullPath.includes('/autenticacao') && !to.fullPath.includes('/credenciamento') && !to.fullPath.includes('/contribuintes') && !to.fullPath.includes('/expired') && !to.fullPath.includes('/recuperarSenha') && !to.fullPath.includes('/reciboRetencao') && !to.fullPath.includes('/consultaRps') && !to.fullPath.includes('/denunciaFiscal') && !to.fullPath.includes('/autenticacaoDigital') && !to.fullPath.includes('/acessoDireto')) {
    let currentUser = LoginService.currentUserValue;
    if (LoginService.isTokenExpired()) {
      LoginService.logOut();
      return next({ path: '/login?expired=S' });
    }
    if (currentUser) {
      UsuarioAcessoService.refreshAccess(currentUser).then(response => {
        currentUser = LoginService.updateStorage(response.data);
      })

      MonitoramentoVisitaService.register({ pagina: to.fullPath });
    }
    if (!currentUser) {
      return next({ path: '/login' });
    } else if ((!currentUser.acessoMenu && to.fullPath != '/selecaoEmpresa' && to.fullPath != '/acessoEmpresa') || to.fullPath == '/') {
      return next({ path: currentUser.homePage });
    } else if (to.fullPath === '/declaracaoNormal' && currentUser && currentUser.configuracao && currentUser.configuracao.idBolModeloFechamento === 'E') {
      return next({ path: '/damNormal' });
    } else if (to.fullPath === '/declaracaoSubstituicao' && currentUser && currentUser.configuracao && currentUser.configuracao.idBolModeloFechamento === 'E') {
      return next({ path: '/damSubstituicao' });
    } else if (to.fullPath === '/relatorioDeclaracao' && currentUser && currentUser.configuracao && currentUser.configuracao.idBolModeloFechamento === 'E') {
      return next({ path: '/relatorioDam' });
    }

  } else if (to.fullPath == '/login' && LoginService.currentUserValue) {
    LoginService.logOut();
  }
  next();
});
export default router;